<a
  [link]="pathToPrepaymentAccountPage()"
  class="flex items-center justify-between"
  (click)="close()"
>
  <i class="icon icon-handout absolute left-5 text-xl"></i>
  <div class="font-accent text-base font-bold text-neutral-800">
    {{ 'sidebar.navigation.credits' | translate }}
  </div>

  <div class="flex items-center gap-2">
    @if (isLoading$ | async) {
      <img
        src="assets/images/spinner.svg"
        alt=""
      />
    }
    <app-tag-atom
      [text]="formatBalance(prepaymentBalanceBeforeOrder())"
      [color]="'neutral-300'"
    />
  </div>
</a>
